function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#D9E5F8",
    style: {
      fill: "#D9E5F8",
      fill: "color(display-p3 0.8494 0.8973 0.9718)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0153 17.4847C24.0502 17.5195 24.0778 17.5609 24.0967 17.6064C24.1156 17.6519 24.1253 17.7007 24.1253 17.75C24.1253 17.7993 24.1156 17.8481 24.0967 17.8936C24.0778 17.9391 24.0502 17.9805 24.0153 18.0153L18.7653 23.2653C18.7305 23.3002 18.6891 23.3278 18.6436 23.3467C18.5981 23.3656 18.5493 23.3753 18.5 23.3753C18.4507 23.3753 18.4019 23.3656 18.3564 23.3467C18.3109 23.3278 18.2695 23.3002 18.2347 23.2653L15.9847 21.0153C15.9143 20.9449 15.8748 20.8495 15.8748 20.75C15.8748 20.6505 15.9143 20.5551 15.9847 20.4847C16.0551 20.4143 16.1505 20.3748 16.25 20.3748C16.3495 20.3748 16.445 20.4143 16.5153 20.4847L18.5 22.4694L23.4847 17.4847C23.5195 17.4498 23.5609 17.4222 23.6064 17.4033C23.6519 17.3844 23.7007 17.3747 23.75 17.3747C23.7993 17.3747 23.8481 17.3844 23.8936 17.4033C23.9391 17.4222 23.9805 17.4498 24.0153 17.4847ZM29.375 20C29.375 21.8542 28.8252 23.6668 27.795 25.2085C26.7649 26.7502 25.3007 27.9518 23.5877 28.6614C21.8746 29.3709 19.9896 29.5566 18.171 29.1949C16.3525 28.8331 14.682 27.9402 13.3709 26.6291C12.0598 25.318 11.1669 23.6475 10.8051 21.829C10.4434 20.0104 10.6291 18.1254 11.3386 16.4123C12.0482 14.6993 13.2498 13.2351 14.7915 12.205C16.3332 11.1748 18.1458 10.625 20 10.625C22.4856 10.6277 24.8686 11.6163 26.6261 13.3739C28.3837 15.1315 29.3723 17.5144 29.375 20ZM28.625 20C28.625 18.2941 28.1192 16.6266 27.1714 15.2082C26.2237 13.7898 24.8767 12.6843 23.3006 12.0315C21.7246 11.3787 19.9904 11.2079 18.3174 11.5407C16.6443 11.8735 15.1074 12.695 13.9012 13.9012C12.695 15.1074 11.8735 16.6443 11.5407 18.3173C11.2079 19.9904 11.3787 21.7246 12.0315 23.3006C12.6843 24.8767 13.7898 26.2237 15.2082 27.1714C16.6266 28.1192 18.2941 28.625 20 28.625C22.2867 28.6225 24.4791 27.713 26.0961 26.0961C27.713 24.4791 28.6225 22.2867 28.625 20Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCheck);
export default __webpack_public_path__ + "static/media/blue-check.7e8e09e42d5642cc8eb724a7d33fc567.svg";
export { ForwardRef as ReactComponent };